export default function (instance) {
    return {
        sendNewPass(body) {
            return instance.post('/api/v2/profile/password/reset', body)
        },
        confirmNewPass(key, body) {
            return instance.post(`/api/v2/profile/password/reset/confirm/${key}`, body)
        }
    }
}